import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { isListCatalogNameGridId } from './listCatalogNameGrid'
import { isParentObjectNameGridId } from './parentObjectNameGrid'

export function parentAccordionFieldIdSet(
  parentAccordionFields: ObjectInventoryField[],
): ReadonlySet<string> {
  return new Set(parentAccordionFields.map((field) => String(field.id)))
}

/** Drawer / save: own type fields — excludes rows loaded only for linked «Справочники» accordions. */
export function isRuntimeOwnCatalogField(
  field: ObjectInventoryField,
  parentAccordionFieldIds: ReadonlySet<string>,
): boolean {
  const id = String(field.id)
  if (isParentObjectNameGridId(id) || isListCatalogNameGridId(id)) return false
  return !parentAccordionFieldIds.has(id)
}

export function filterRuntimeOwnCatalogFields(
  fields: ObjectInventoryField[],
  parentAccordionFieldIds: ReadonlySet<string>,
): ObjectInventoryField[] {
  return fields.filter((field) => isRuntimeOwnCatalogField(field, parentAccordionFieldIds))
}
